import { Users, Server, DollarSign, CreditCard } from 'lucide-react';

export const Icons = {
  users: Users,
  server: Server,
  dollarSign: DollarSign,
  creditCard: CreditCard,
};